export default __webpack_public_path__ + "static/media/logo.18a1f1df.png";